var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('error',{attrs:{"icon":"mdi-cloud-search-outline","title":"No internet connection","action":{ title: 'Try again', event: 'click' }},on:{"click":_vm.handle}},[_c('p',[_vm._v("Please check your network connection and try again.")])])}
var staticRenderFns = []

export { render, staticRenderFns }